// hooks/useUnreadCountsByTickets.js
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const useUnreadCountsByTickets = (tickets = []) => {
  const notifications =
    useSelector((state) => state.notificationsList?.notifyInfo) || [];

  const sharedLogin = useSelector((state) => state?.sharedLogin);
  const tokenInfoList = useSelector((state) => state.tokenInfoList);

  const { sharedUserInfo } = sharedLogin;

  let companyId;
  let userId;

  if (tokenInfoList?.info?.type === "admin") {
    companyId = tokenInfoList?.info?.company?._id;
    userId = tokenInfoList?.info?._id;
  } else if (sharedUserInfo?.empCompanies?.length > 0) {
    companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    userId = tokenInfoList?.info?._id;
  }

  return useMemo(() => {
    if (!Array.isArray(notifications) || !userId) return {};

    const counts = {};

    tickets.forEach((ticket) => {
      counts[ticket._id] = notifications.reduce((count, notification) => {
        if (
          notification.type === "support_message" &&
          notification.id === ticket._id
        ) {
          const unread = notification.receiveTo.some(
            (r) => r.userId === userId && r.markAsRead === false
          );

          return count + (unread ? 1 : 0);
        }

        return count;
      }, 0);
    });

    return counts;
  }, [notifications, tickets, userId]);
};
